import axios from "axios";
import history from "../history";

//Configuration
const fetch = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL + '/api',
  timeout: 60000,
});

fetch.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

fetch.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.log(error);
    if (error.response?.status === 401) {
      history.push("/");
    }

    return Promise.reject(error);
  }
);

const ApiService = {};

ApiService.getPayments = (data) => {
  return fetch({
    url: "/get-payments",
    method: "POST",
    data
  });
};

ApiService.getOutlets = (data) => {
  return fetch({
    url: "/get-outlets",
    method: "GET",
  });
};

ApiService.removePayment = (data) => {
  return fetch({
    url: "/remove-payment",
    method: "POST",
    data
  });
};

ApiService.saveCardPayment = (data) => {
  return fetch({
    url: "/save-card-payment",
    method: "POST",
    data
  });
};

ApiService.saveCheckPayment = (data) => {
  return fetch({
    url: "/save-check-payment",
    method: "POST",
    data
  });
};

export default ApiService;
